<template>
  <div class="create-professional-group">
    <Header />
    <Main>
      <h3 class="text-center">
        Создание профгруппы в профсоюзе "{{ unionName }}"
      </h3>
      <b-overlay :show="loading">
        <professional-group-form
          v-model="professionalGroupData"
          class="create-professional-group__form"
        />
      </b-overlay>
    </Main>
    <bottom-overlay v-if="edited">
      <b-button
        @click="createProfessionalGroup"
        block
        squared
        variant="success"
        class="create-person__create-button"
        :disabled="loading"
      >
        Создать профгруппу
      </b-button>
    </bottom-overlay>
  </div>
</template>
<script>
import Header from "@/components/Layout/Header";
import Main from "@/components/Layout/Main";
import BottomOverlay from "@/components/BottomOverlay";
import store from "@/store";
import ProfessionalGroupModel from "@/components/Forms/Union/ProfessionalGroup/models/professionalGroupModel";
import ProfessionalGroupForm from "@/components/Forms/Union/ProfessionalGroup/ProfessionalGroupForm";
import { mapGetters } from "vuex";
import pageTitleMixin from "@/mixins/pageTitleMixin";
export default {
  components: { ProfessionalGroupForm, BottomOverlay, Main, Header },
  mixins: [pageTitleMixin],
  props: {
    unionId: {
      type: Number,
      required: true
    }
  },
  data() {
    let professionalGroupData = new ProfessionalGroupModel();
    professionalGroupData.union_id = this.unionId;
    return {
      professionalGroupData,
      loading: false
    };
  },
  methods: {
    async createProfessionalGroup() {
      this.loading = true;
      try {
        let res = await store.dispatch(
          "professionalGroups/createProfessionalGroup",
          this.professionalGroupData
        );
        this.$router.push(
          `/unions/${this.unionId}/professional-groups/${res.data.union_professional_group.id}`
        );
      } catch {
        this.loading = false;
      }
    }
  },
  computed: {
    ...mapGetters("unions", ["unions"]),
    union: ({ unions, unionId }) =>
      unions.find(({ id }) => Number(id) === unionId),
    unionName: ({ union }) => (union !== undefined ? union.name : ""),
    edited: ({ professionalGroupData }) =>
      JSON.stringify(professionalGroupData) !==
      JSON.stringify(new ProfessionalGroupModel())
  }
};
</script>

<style lang="scss">
.create-professional-group {
  &__form {
    margin: 0 5px;
  }
}
</style>
